import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnnouncementDetails } from '@app/app/shared/models/messages/messages.model';
import { LucideArrowRight, LucideBell, LucideUsers } from '@lucide/angular';

@Component({
  selector: 'ptl-engagement-card',
  templateUrl: './engagement-card.component.html',
  styleUrls: ['./engagement-card.component.scss'],
})
export class EngagementCardComponent {
  @Input() announcementCount = 0;
  @Input() latestAnnouncement: AnnouncementDetails | null = null;

  @Output() announcementsClick = new EventEmitter<void>();
  @Output() discussionsClick = new EventEmitter<void>();

  protected readonly LucideBell = LucideBell;
  protected readonly LucideUsers = LucideUsers;
  protected readonly LucideArrowRight = LucideArrowRight;
}
